$(document).ready(function () {
    $(".single-new-card").on("click", ".image-wrapper--arrow", function (event) {
        var sectionWrapper = $(this).closest(".section-wrapper");
        var additionalText = sectionWrapper.next(
            ".additional-text-wrapper"
        );
        if (additionalText.length > 0) {
            var arrowImage = $(this).find("img");
            if (arrowImage.attr("src").includes("arrow-down.svg")) {
                arrowImage.attr("src", "/images/arrow-up.svg");
            } else {
                arrowImage.attr("src", "/images/arrow-down.svg");
            }
            additionalText.toggleClass("active");
        }
    });
});
